import { IProductDefinition } from '@ads/front-core/products/IProductDefinition'
import { Cursor } from '@ads/front-core/Icons/wizard'
import { lng } from '@ads/front-core/locales'
import limits from '@ads/front-core/constants/limits'
import { ProductFor, WizardSubCategoryEnum } from '@ads/front-core/interfaces'

export const UNIVERSAL_CPC: IProductDefinition = {
  productTypeId: 'UNIVERSAL_CPC',
  productAvailableFor: [ProductFor.NONPUBLISHER],
  createUrl: '/campaign/create/universal-cpc/',
  title: 'campaign:displayCPC.displayCPC',
  budget: {
    model: 'CPC',
    type: 'TOTAL',
    variant: 'ANY',
    validation: {
      globalLimit: {
        min: limits.MINIMUM_BUDGET,
      },
      dailyLimit: {
        min: limits.MINIMUM_DAILY_BUDGET,
      },
      rate: {
        min: 0.3,
      },
    },
  },
  campaignHowToWorks: 'campaign:displayCPC.howDisplayCPCWorks',
  campaignMinimumRates: {
    fields: ['DEFAULT'],
    inputType: 'currency',
  },
  campaignWPBoosterRequirements: ['smartTargeting', 'pixel', 'creations'],
  allowedCreationTypes: ['BANNER', 'HTML', 'CODE', 'RICH_MEDIA'],
  creationsDescription: 'campaign:displayCPC.addMoreCreationsDescription',
  targeting: {
    countries: true,
    demography: true,
    devices: true,
    emitToTrusted: true,
    locations: true,
    smartTargeting: true,
    optimizationMetric: true,
    segmentsTab: ['segments', 'retargetingSegments'],
  },
  wizard: {
    subCategory: WizardSubCategoryEnum.DISPLAY,
    productDescription: {
      title: `${lng('common:clicks')} (natywne api)`,
      description: lng('wizard:displayCPCDescription'),
      Icon: Cursor,
      wpBooster: true,
    },
    parameters: [
      {
        label: lng('campaign:format'),
        value: lng('campaign:banner'),
      },
      {
        label: lng('campaign:billingModel'),
        value: lng('wizard:budgetModel.cpc'),
      },
      {
        label: lng('wizard:destination'),
        value: lng('campaign:trafficAcquisition'),
      },
    ],
  },
}
